import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Passengers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1 && this.loginDetails.userType != 40)
                this.logout();
        } else {
            this.logout();
        }

        if (this.loginDetails && this.loginDetails.userType == 40) {
            this.SchoolsId = this.getSchoolId();
        }

        this.GetAllSchools();
        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            Type: null,
            SchoolsId: null,

            ScreenTitle: '  الركاب الموقوفين  ',
            ScreenTitleSingle: '  راكب   موقوف',
            ScreenTitleSingleAl: 'الراكب ',

            Info: [],
            Statistics: [],
            SchoolsList: [],
            SuspendReason: '',
            SelectedItem: null,
            state:3,
            ruleForm: {
                Id: '',
                UserId: null,
                SchoolsId: null,
                FirstName: '',
                FatherName: '',
                SirName: '',
                Name: '',
                Phone: '',
                Type: 1,
                Descriptions: ''
            },
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Required(),
                Type: this.$helper.Required()
            }
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetPassengers(this.pageNo, this.pageSize, this.Search, this.Type, this.SchoolsId , this.state )
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                    this.Info = [];
                });
        },

        GetAllSchools() {
            this.$http.GetAllSchools()
                .then(response => {
                    this.SchoolsList = response.data.info || [];
                })
                .catch(() => {
                    this.SchoolsList = [];
                });
        }, openSuspendModal(Id) {
            this.SuspendDriverId = Id;
            this.SuspendReason = '';
        },
        submitSuspend() {
            if (!this.SuspendReason || !this.SuspendDriverId) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى إدخال سبب التعليق');
                return;
            }
            this.$blockUI.Start();
            this.$http.SuspendPassengers({ PassengerId: this.SuspendDriverId, Reason: this.SuspendReason }


            )

                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تعليق الركاب');
                    this.SuspendDriverId = null;
                    this.SuspendReason = '';
                    this.$helper.DestroyElemntById('CloseSuspend');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        }, CancelSuspend(Id) {
            Swal.fire({ title: 'إلغاء التعليق', text: 'هل أنت متأكد من إلغاء تعليق الركاب؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.CancelSuspendPassengers(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إلغاء التعليق'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },
        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        submitForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = null;
                    const body = {
                        Id: null,
                        UserId: this.ruleForm.UserId || null,
                        SchoolsId: this.ruleForm.SchoolsId ? Number(this.ruleForm.SchoolsId) : null,
                        FirstName: this.ruleForm.FirstName || null,
                        FatherName: this.ruleForm.FatherName || null,
                        SirName: this.ruleForm.SirName || null,
                        Name: this.ruleForm.Name,
                        Phone: this.ruleForm.Phone,
                        Type: Number(this.ruleForm.Type) || 1,
                        Descriptions: this.ruleForm.Descriptions || null
                    };
                    this.$blockUI.Start();
                    this.$http.AddPassengers(body)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.ruleForm.Type = 1;
                            this.$helper.DestroyElemntById('CloseAdd');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدث خطأ غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UserId = item.userId || null;
            this.ruleForm.SchoolsId = item.schoolsId || null;
            this.ruleForm.Name = item.name || '';
            this.ruleForm.Phone = item.phone || '';
            this.ruleForm.Type = item.type != null ? item.type : 1;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.ruleForm.FirstName = item.firstName || '';
            this.ruleForm.FatherName = item.fatherName || '';
            this.ruleForm.SirName = item.sirName || '';
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (valid) {
                    const body = {
                        Id: Number(this.ruleForm.Id),
                        UserId: this.ruleForm.UserId || null,
                        SchoolsId: this.ruleForm.SchoolsId ? Number(this.ruleForm.SchoolsId) : null,
                        FirstName: this.ruleForm.FirstName || null,
                        FatherName: this.ruleForm.FatherName || null,
                        SirName: this.ruleForm.SirName || null,
                        Name: this.ruleForm.Name,
                        Phone: this.ruleForm.Phone,
                        Type: Number(this.ruleForm.Type) || 1,
                        Descriptions: this.ruleForm.Descriptions || null
                    };
                    this.$blockUI.Start();
                    this.$http.EditPassengers(body)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.ruleForm.Type = 1;
                            this.$helper.DestroyElemntById('CloseEdit');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدث خطأ غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هل انت متأكد من عملية الحذف ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeletePassengers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        typeLabel(type) {
            if (type === 1) return 'راكب';
            if (type === 2) return 'طالب';
            return type;
        }
    }
};
